<template>
  <v-container fluid class="text-center pa-4 elevation-4 d-flex align-center justify-space-around">
    <div>
      <a
        icon
        v-for="site in socialMedia"
        :key="site.site"
        :href="`${site.link}`"
        target="_blank"
        class="link"
        variant="text"
        :ripple="false"
      >
        <v-icon medium>
          {{ site.mdiIcon }}
        </v-icon>
      </a>      
    </div>
    <div class="nav-footer">
      <v-icon>
        mdi-copyright
      </v-icon>
      {{ currentYear }} - Darcey Grundy
    </div>
  </v-container>  
</template>
    
<script>
export default {
  name: 'footerPage',  
  data: () => ({
    socialMedia: [
      // {
      //   link: 'https://mastodon.social/@pullrequestsandpersonalrecords',
      //   mdiIcon: 'mdi-mastodon'
      // },
      // {
      //   link: 'http://instagram.com/pullrequestsandpersonalrecords',
      //   mdiIcon: 'mdi-instagram'
      // },
      {
        link: 'https://www.linkedin.com/in/darcey-grundy/',
        mdiIcon: 'mdi-linkedin'
      },
      {
        link: 'https://github.com/grundydarcey',
        mdiIcon: 'mdi-github'
      }
    ],
    currentYear: new Date().getFullYear(),
  }),
}
</script>

<style lang="scss" scoped>
.link:hover {
  background-color: transparent !important;
}

:deep(.link .v-btn__overlay),
:deep(.link .v-btn__underlay) {
  display: none !important;
}

.nav-footer {
  font-family: Bebas Neue;
  color: rgba(0, 0, 0, 0.54);
}
</style>